<template>
  <b-modal
    :visible="showDeleteModal"
    id="deleteJobModal"
    size="lg"
    centered
    hide-footer
    hide-header
    @show="clearData"
    no-close-on-backdrop
    @hidden="$emit('closeDeleteJd')"
  >
    <div class="d-flex align-items-center justify-content-between p-3">
      <div class="b-modal-header">
        {{ type == "close" || fromClose ? "Close" : "Delete" }} Job
      </div>
      <div @click="$emit('closeDeleteJd')" class="rotate-on-hover pointer">
        <img
          v-b-tooltip.hover.top="'Close'"
          src="../../../assets/img/accessconnew/blueCross.svg"
          alt
        />
      </div>
    </div>
    <hr class="my-0" />
    <div class="px-3">
      <div class="mt-3 d-flex align-items-center">
        <div>
          <img
            src="../../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
            alt=""
          />
        </div>

        <div v-if="type == 'close' || fromClose" class="new-blck-font ml-3">
          Are you sure you want to close this job?
        </div>

        <div v-else class="new-blck-font ml-3">
          Are you sure you want to delete this job
          <strong style="color: #20639b">"{{ deleteData.title }}"</strong>?
        </div>
      </div>

      <div v-show="deleteData.approved" class="mt-3">
        <span class="new-head-font"
          >Please update the position IDs status:</span
        >
        <span class="new-grey-font"
          >(it will be updated to all the active position IDs)</span
        >
      </div>
      <div
        v-show="deleteData.approved"
        class="mt-1 new-center-radio d-flex align-items-center"
      >
        <b-form-radio
          v-show="deleteData.approved"
          v-model="deleteJobData.positionStatus"
          class="wordbreak"
          value="4"
        >
          Lost
        </b-form-radio>
        <b-form-radio
          v-show="deleteData.approved"
          v-model="deleteJobData.positionStatus"
          class="wordbreak ml-3"
          value="0"
        >
          Cancelled
        </b-form-radio>
      </div>
      <div class="newmodalinputbox mt-3">
        <div class="jdk-ip-confirm-subtxt">
          Comments<span class="asterik">*</span>
        </div>
        <b-form-textarea
          :class="{ error: $v.deleteJobData.comments.$error }"
          v-model="deleteJobData.comments"
          rows="2"
          type="text"
          max-rows="5"
          placeholder="Enter"
        >
        </b-form-textarea>
        <div
          class="errortxt position-absolute"
          v-if="
            $v.deleteJobData.comments.$dirty &&
            !$v.deleteJobData.comments.required
          "
        >
          Required
        </div>
        <div
          v-else-if="!$v.deleteJobData.comments.maxLength"
          class="errortxt position-absolute"
        >
          Exceeded the max char length of 256
        </div>
      </div>
    </div>
    <hr />
    <div
      class="d-flex align-items-center w-100 bluebtn pb-3"
      :class="type ? 'justify-content-between' : 'justify-content-end'"
    >
      <b-button
        v-show="type"
        @click="$emit('go-to-close')"
        class="acs-cancelBtn-modal ml-3"
        >Previous</b-button
      >
      <div class="d-flex">
        <b-button
          @click="$emit('closeDeleteJd')"
          class="acs-cancelBtn-modal mr-3"
          >Cancel</b-button
        >
        <div class="position-relative">
          <div class="addpanellog position-relative">
            <b-button
              class="acs-addBtn-modal pl-4 pr-4 mr-3"
              @click="buttonLoader ? '' : deleteJob()"
              :class="buttonLoader ? 'givefeed-loader-class' : 'pointer'"
            >
              <span v-if="!buttonLoader">
                {{ type == "close" || fromClose ? "Update" : "Delete" }}
              </span>
            </b-button>

            <div v-if="buttonLoader" class="loader-pos">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import Loader from "../../../components/fixedcomponents/Loader.vue";
export default {
  name: "DeleteJobModal",
  props: {
    type: String,
    showDeleteModal: Boolean,
    buttonLoader: Boolean,
    fromClose: Boolean,
    deleteData: Object,
  },
  components: {
    Loader,
  },
  validations: {
    deleteJobData: {
      comments: {
        required,
        maxLength: maxLength(256),
      },
    },
  },
  data() {
    return {
      deleteJobData: {
        positionStatus: 4,
        comments: "",
      },
    };
  },
  methods: {
    clearData() {
      this.deleteJobData = {
        positionStatus: 4,
        comments: "",
      };
      this.$v.deleteJobData.comments.$reset();
    },
    deleteJob() {
      this.$v.deleteJobData.comments.$touch();
      if (!this.$v.deleteJobData.comments.$invalid) {
        if (!this.deleteData.approved) {
          this.deleteJobData.positionStatus = 0;
        }
        this.showLoader = true;
        this.$emit("delete-event", this.deleteJobData);
      }
    },
  },
};
</script>

<style scoped>
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 95px;
}
</style>
